// Portuguese translations
const pt = {
  cover: {
    title: "Reino do Xadrez",
    subtitle: "Corte do Rei",
    riseOfDukes: "A Ascensão dos Duques",
    enter: "ENTRAR",
    aboutUs: "SOBRE NÓS",
    tagline: "Onde lendas nascem, e cada jogada conta uma história",
    selectLanguage: "Selecionar Idioma"
  },
  auth: {
    login: "Entrar",
    register: "Registrar",
    email: "Email",
    password: "Senha",
    confirmPassword: "Confirmar Senha",
    username: "Nome de Usuário",
    forgotPassword: "Esqueceu a senha?",
    noAccount: "Não tem uma conta?",
    hasAccount: "Já tem uma conta?",
    signUp: "Cadastrar",
    signIn: "Entrar",
    orContinueWith: "Ou continue com",
    guest: "Jogar como Convidado",
    logout: "Sair"
  },
  lobby: {
    title: "SAGUÃO",
    subtitleRise: "A Ascensão dos",
    subtitleDukes: "Duques",
    quickPlay: "JOGO RÁPIDO",
    createRoom: "CRIAR SALA",
    joinRoom: "ENTRAR",
    settings: "Configurações",
    skins: "SKINS",
    friends: "Amigos",
    chat: "Chat",
    spectate: "ASSISTIR",
    roomCode: "Código da Sala",
    enterRoomCode: "Digite o código...",
    join: "Entrar",
    create: "Criar",
    private: "Privada",
    public: "Pública",
    players: "Jogadores",
    waiting: "Aguardando oponente...",
    ready: "Pronto",
    start: "Iniciar",
    gameSetup: "CONFIGURAÇÃO",
    chooseVariant: "Escolher Variante e Modo",
    multiplayer: "MULTIJOGADOR",
    onlineMatches: "Partidas Online",
    profile: "Perfil",
    messages: "Mensagens",
    assistant: "Assistente",
    help: "Ajuda",
    exit: "Sair"
  },
  game: {
    white: "Brancas",
    black: "Pretas",
    whiteToMove: "Brancas Jogam",
    blackToMove: "Pretas Jogam",
    check: "Xeque!",
    checkmate: "Xeque-Mate!",
    stalemate: "Afogamento!",
    draw: "Empate",
    resign: "Abandonar",
    resigns: "Abandona",
    forfeits: "Perde por W.O.",
    offerDraw: "Oferecer Empate",
    acceptDraw: "Aceitar Empate",
    declineDraw: "Recusar Empate",
    newGame: "Nova Partida",
    leave: "Sair",
    rules: "REGRAS",
    moveHistory: "Histórico",
    noMovesYet: "Nenhum lance ainda",
    movesWillAppear: "Os lances aparecerão aqui",
    yourTurn: "Sua Vez",
    opponentTurn: "Vez do Oponente",
    gameOver: "Fim de Jogo",
    youWin: "VOCÊ VENCEU!",
    youLose: "Você Perdeu",
    whiteWins: "Brancas Vencem!",
    blackWins: "Pretas Vencem!",
    drawGame: "Empate!",
    playAgain: "Jogar Novamente",
    backToLobby: "Voltar ao Saguão",
    classic: "CLÁSSICO",
    kingsCourt: "CORTE DO REI",
    fightToBeKing: "Luta pelo Trono",
    kingCaptured: "Rei Capturado!",
    winner: "Vencedor",
    rematch: "Revanche",
    decline: "Recusar",
    waiting: "Aguardando...",
    acceptRematch: "Aceitar Revanche",
    wantsRematch: "quer revanche!",
    rematchAccepted: "Revanche aceita! Iniciando nova partida...",
    rematchDeclined: "Revanche recusada. Voltando ao saguão...",
    waitingForOpponent: "Aguardando oponente...",
    startingNewGame: "Iniciando nova partida...",
    continue: "Continuar"
  },
  settings: {
    title: "Configurações",
    boardCustomization: "Personalização do Tabuleiro e Peças",
    livePreview: "Prévia ao Vivo",
    previewDescription: "Veja suas personalizações",
    boardTheme: "Cores do Tabuleiro",
    pieceTheme: "Cores das Peças",
    customColors: "Cores Personalizadas",
    presetThemes: "Temas Predefinidos",
    lightSquares: "Casas Claras",
    darkSquares: "Casas Escuras",
    whitePieces: "Peças Brancas",
    blackPieces: "Peças Pretas",
    coordinateColor: "Cor das Coordenadas",
    coordinateDescription: "Personalize números (1-8) e letras (a-h)",
    chessPieceSkins: "Skins das Peças",
    chessPieceSkinsDescription: "Substitua peças padrão por skins 3D premium",
    dukeSkins: "Skins do Duque",
    dukeSkinsDescription: "Escolha skins do Duque - cores se adaptam!",
    whiteSideDuke: "Duque Lado Branco",
    blackSideDuke: "Duque Lado Preto",
    autoMatchBoard: "Adaptar cores automaticamente",
    saveAndClose: "Salvar e Fechar",
    reset: "Restaurar Padrões",
    close: "Fechar",
    premium: "Premium",
    default: "Padrão",
    classic: "Clássico",
    viewMode: "Modo de Visualização",
    viewModeDescription: "Escolha como ver o tabuleiro",
    topDown: "Vista Superior",
    topDownDescription: "Vista plana como tabuleiros tradicionais",
    perspective3D: "Perspectiva 3D",
    perspective3DDescription: "Peças 2D com ângulo 3D dinâmico",
    skinsApplyTo: "Skins para Rei, Dama, Torre, Bispo, Cavalo, Peão",
    dukeHint: "Esquerda: Rei Instantâneo · Direita: Luta pelo Trono"
  },
  store: {
    title: "Loja de Skins",
    subtitle: "Corte do Rei",
    riseOfDukes: "A Ascensão dos Duques",
    chessPieces: "Peças de Xadrez",
    dukeSkins: "Skins do Duque",
    allPiecesBundle: "Pacote Todas as Peças",
    allDukeBundle: "Pacote Todos os Duques",
    bundleDiscount: "Todas as skins premium com 30% de desconto!",
    owned: "Adquirido",
    equip: "Equipar",
    buy: "Comprar",
    processing: "Processando...",
    free: "Grátis",
    rare: "raro",
    epic: "épico",
    legendary: "lendário",
    common: "comum",
    securePayment: "Compra única • Use para sempre • Pagamento seguro"
  },
  chat: {
    title: "Chat",
    lobbyChat: "Chat do Saguão",
    gameChat: "Chat da Partida",
    typeMessage: "Digite uma mensagem...",
    send: "Enviar",
    spectatorChat: "Chat Espectadores",
    playerChat: "Chat Jogadores"
  },
  friends: {
    title: "Amigos",
    online: "Online",
    offline: "Offline",
    addFriend: "Adicionar Amigo",
    removeFriend: "Remover",
    invite: "Convidar",
    pending: "Pendente",
    accept: "Aceitar",
    decline: "Recusar",
    friendRequests: "Pedidos de Amizade",
    noFriends: "Ainda sem amigos",
    searchPlayers: "Buscar jogadores..."
  },
  notifications: {
    friendRequest: "enviou um pedido de amizade",
    gameInvite: "convidou você para jogar",
    yourTurn: "É sua vez!",
    opponentJoined: "Oponente entrou na partida",
    opponentLeft: "Oponente saiu da partida",
    drawOffered: "Oponente ofereceu empate",
    connected: "Conectado ao servidor",
    disconnected: "Desconectado do servidor",
    reconnecting: "Reconectando..."
  },
  errors: {
    invalidEmail: "Endereço de email inválido",
    invalidPassword: "A senha deve ter pelo menos 6 caracteres",
    passwordMismatch: "As senhas não coincidem",
    loginFailed: "Falha no login. Verifique suas credenciais.",
    registerFailed: "Falha no registro. Tente novamente.",
    connectionError: "Erro de conexão. Tente novamente.",
    connectionErrorInternet: "Erro de conexão. Verifique sua internet.",
    gameNotFound: "Partida não encontrada",
    roomFull: "Sala cheia",
    invalidMove: "Lance inválido",
    pleaseEnterName: "Por favor, insira seu nome",
    completeBothSecurityQuestions: "Complete ambas as perguntas de segurança ou deixe vazias",
    selectDifferentQuestions: "Por favor, selecione perguntas diferentes",
    unexpectedError: "Ocorreu um erro inesperado",
    failedToSendResetCode: "Falha ao enviar código de redefinição",
    invalidOrExpiredCode: "Código inválido ou expirado",
    failedToResetPassword: "Falha ao redefinir senha. Tente novamente.",
    pleaseEnterRoomName: "Por favor, insira um nome de sala",
    pleaseEnterRoomCode: "Por favor, insira um código de sala",
    roomCodeMustBe6Chars: "O código deve ter 6 caracteres",
    roomNotFound: "Sala não encontrada. Verifique o código.",
    roomRequiresApproval: "Esta sala requer aprovação. Solicite da sua lista.",
    failedToCreateRoom: "Falha ao criar sala",
    failedToJoinRoom: "Falha ao entrar na sala",
    failedToLeaveRoom: "Falha ao sair da sala",
    failedToRemoveRoom: "Falha ao remover sala",
    failedToLoadGames: "Falha ao carregar jogos",
    failedToRequestRejoin: "Falha ao solicitar reentrada",
    failedToJoinMatchmaking: "Falha ao entrar no matchmaking",
    noOpponentFound: "Nenhum oponente encontrado. Tente mais tarde.",
    searchFailed: "Busca falhou",
    failedToSendRequest: "Falha ao enviar solicitação",
    failedToAcceptRequest: "Falha ao aceitar solicitação",
    failedToRejectRequest: "Falha ao rejeitar solicitação",
    failedToCancelRequest: "Falha ao cancelar solicitação",
    failedToRemoveFriend: "Falha ao remover amigo"
  },
  success: {
    copiedToClipboard: "Copiado para área de transferência!",
    rejoinRequestSent: "Solicitação enviada ao anfitrião!",
    roomRemovedFromList: "Sala removida da sua lista.",
    leftRoomSuccessfully: "Saiu da sala com sucesso",
    requestRejected: "Solicitação rejeitada",
    requestCancelled: "Solicitação cancelada",
    friendRemoved: "Amigo removido",
    tournamentCreated: "Torneio criado com sucesso!",
    tournamentJoined: "Entrou no torneio com sucesso!",
    tournamentLeft: "Saiu do torneio",
    tournamentStarted: "Torneio iniciado!",
    tournamentCancelled: "Torneio cancelado",
    tournamentsCleared: "Todos os torneios removidos",
    removedFromHistory: "Removido do histórico"
  },
  tournament: {
    title: "Torneios",
    createTournament: "Criar Torneio",
    joinTournament: "Entrar no Torneio",
    leaveTournament: "Sair do Torneio",
    startTournament: "Iniciar Torneio",
    cancelTournament: "Cancelar Torneio",
    clearAll: "Limpar Tudo",
    myTournaments: "Meus Torneios",
    availableTournaments: "Torneios Disponíveis",
    tournamentHistory: "Histórico de Torneios",
    bracket: "Chave",
    participants: "Participantes",
    status: "Status",
    waiting: "Aguardando",
    inProgress: "Em Andamento",
    completed: "Concluído",
    cancelled: "Cancelado",
    format: "Formato",
    singleElimination: "Eliminação Simples",
    doubleElimination: "Eliminação Dupla",
    swiss: "Suíço",
    round: "Rodada",
    match: "Partida",
    ready: "Pronto",
    notReady: "Não Pronto",
    markReady: "Marcar Pronto",
    winner: "Vencedor",
    loser: "Perdedor",
    bye: "Bye",
    pleaseLoginToCreate: "Faça login para criar um torneio",
    pleaseLoginToJoin: "Faça login para entrar em um torneio",
    failedToLoadTournaments: "Falha ao carregar torneios",
    failedToCreateTournament: "Falha ao criar torneio",
    failedToJoinTournament: "Falha ao entrar no torneio",
    failedToLeaveTournament: "Falha ao sair do torneio",
    failedToStartTournament: "Falha ao iniciar torneio",
    failedToCancelTournament: "Falha ao cancelar torneio",
    failedToClearTournaments: "Falha ao limpar torneios",
    failedToRemoveFromHistory: "Falha ao remover do histórico",
    failedToLoadTournament: "Falha ao carregar torneio",
    failedToMarkReady: "Falha ao marcar como pronto"
  },
  ranked: {
    title: "Ranqueado",
    findMatch: "Buscar Partida Ranqueada",
    inQueue: "Na Fila...",
    leaveQueue: "Sair da Fila",
    yourRank: "Seu Rank",
    elo: "ELO",
    tier: "Tier",
    wins: "Vitórias",
    losses: "Derrotas",
    draws: "Empates",
    season: "Temporada",
    leaderboard: "Ranking",
    squire: "Escudeiro",
    knight: "Cavaleiro",
    baron: "Barão",
    duke: "Duque",
    king: "Rei",
    pleaseLoginToPlay: "Faça login para jogar ranqueado",
    failedToJoinQueue: "Falha ao entrar na fila"
  },
  misc: {
    loading: "Carregando...",
    cancel: "Cancelar",
    confirm: "Confirmar",
    yes: "Sim",
    no: "Não",
    ok: "OK",
    save: "Salvar",
    delete: "Excluir",
    edit: "Editar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    search: "Buscar",
    filter: "Filtrar",
    sort: "Ordenar",
    all: "Todos",
    none: "Nenhum",
    select: "Selecionar",
    selected: "Selecionado"
  },
  
  // About Us Page
  aboutUs: {
    back: "← Voltar",
    title: "Bem-vindo ao Chess Kingdom: King's Court",
    subtitle: "Corte do Rei",
    riseOfDukes: "A Ascensão dos Duques",
    description: "Entre em um reino onde a estratégia clássica encontra a escala mítica. King's Court é mais que um modo de jogo - é um campo de provas para táticos, sonhadores e campeões. Seja você um grande mestre buscando novo desafio ou um novato atraído pela emoção da conquista, esta é sua arena. ⚔️",
    keyFeatures: "Características Principais",
    feature1Title: "Variantes Dinâmicas",
    feature1Desc: "Explore conjuntos de regras e layouts de tabuleiro em evolução que testam sua adaptabilidade e previsão.",
    feature2Title: "Progressão da Corte",
    feature2Desc: "Ganhe títulos, desbloqueie emblemas e suba através de um sistema de ranking ricamente estratificado que recompensa maestria e estilo.",
    feature3Title: "Jogo Baseado em Habilidade",
    feature3Desc: "Feedback transparente, balanceamento ajustado por telemetria e matchmaking justo garantem que cada vitória seja merecida.",
    feature4Title: "Chat ao Vivo e Histórias",
    feature4Desc: "Conecte-se com rivais e aliados, descubra o lore procedural e molde a mitologia do seu reino.",
    feature5Title: "Feito para Profissionais",
    feature5Desc: "Ajuste de precisão, análise de replay e infraestrutura pronta para torneios fazem do King's Court uma plataforma séria para jogo competitivo.",
    closingStatement: "Seja buscando glória, crescimento ou grande estratégia, King's Court te convida a reinar com sabedoria, lutar com honra e deixar sua marca no reino.",
    developmentNotice: "Nota: O jogo ainda está em desenvolvimento, e com sua paciência e apoio, o jogo se tornará um lar longe de casa. Divirta-se, faça amigos e alianças, pois quando eu terminar, seus métodos estratégicos de vitória serão testados... Bem-vindo ao seu Reino...",
    contactTitle: "Mais informações ou sugestões Contate:",
    contactEmail: "CKKC.customerservice@gmail.com"
  },
  
  // Store
  store: {
    title: "Loja de Skins",
    themedSets: "Conjuntos Temáticos",
    pieceSkins: "Skins de Peças",
    dukeSkins: "Skins de Duque",
    unlockSet: "Desbloquear Conjunto",
    owned: "Possuído",
    price: "Preço",
    checkout: "Finalizar Compra",
    addToCart: "Adicionar ao Carrinho",
    cart: "Carrinho",
    total: "Total",
    continueShopping: "Continuar Comprando",
    proceedToCheckout: "Prosseguir para Pagamento",
    emptyCart: "Seu carrinho está vazio",
    itemAdded: "Item adicionado ao carrinho",
    purchaseSuccess: "Compra realizada com sucesso!",
    purchaseFailed: "Compra falhou. Por favor, tente novamente."
  },
  
  // Rules
  rules: {
    title: "Regras do Jogo",
    classic: "Xadrez Clássico",
    classicDesc: "Regras padrão de xadrez - dê xeque-mate no rei adversário para vencer.",
    instantKing: "Rei Instantâneo",
    instantKingDesc: "Capture o rei inimigo diretamente para vencer - sem necessidade de xeque-mate!",
    fightToBeKing: "Luta para ser Rei",
    fightToBeKingDesc: "Seu peão promovido se torna o novo rei! Proteja-o ou perca o jogo.",
    timerRules: "Regras do Timer",
    timerDesc: "Cada jogador tem tempo limitado por jogada. Se o tempo acabar, seu turno é pulado."
  },
  
  // Assistant
  assistant: {
    title: "Assistente Chess Kingdom",
    searchPlaceholder: "Buscar tópicos de ajuda...",
    randomTip: "Mostrar uma dica aleatória",
    noResults: "Nenhum tópico encontrado para",
    noResultsHint: "Tente palavras-chave diferentes ou navegue pelas categorias acima",
    categories: {
      gettingStarted: "Começando",
      dukeMechanics: "Mecânicas do Duque",
      multiplayer: "Multijogador",
      customization: "Personalização",
      boardFeatures: "Recursos do Tabuleiro",
      skinStore: "Loja de Skins",
      trialPayments: "Teste e Pagamentos",
      strategyTips: "Estratégia",
      troubleshooting: "Solução de Problemas"
    },
    gettingStarted: {
      q1: "Como começo a jogar?",
      a1: "Clique em 'Jogar Solo' para jogar contra IA, ou 'Multijogador' para jogar com outros. Você pode jogar como convidado ou se registrar para um teste gratuito de 48 horas.",
      q2: "Quais são as variantes do jogo?",
      a2: "Chess Kingdom oferece 7 variantes: Xadrez Padrão, Rei Instantâneo, Luta para ser Rei, Escolha do Jogador, Peões Selvagens, Chess Kingdom (Dois Duques) e Modo Handicap.",
      q3: "Como personalizo o tabuleiro?",
      a3: "Clique em Configurações para acessar as opções. Você pode mudar cores do tabuleiro, skins das peças, skins do duque, temas, cor das coordenadas, modo de visualização e tamanho do tabuleiro.",
      q4: "Como viro a visualização do tabuleiro?",
      a4: "Clique no botão virar no cabeçalho do jogo para ver o tabuleiro da perspectiva das pretas.",
      q5: "Como mudo o tamanho do tabuleiro?",
      a5: "Vá em Configurações → Tamanho do Tabuleiro. Use o controle deslizante ou clique em 'Compacto' (85%), 'Padrão' (100%) ou 'Grande' (115%)."
    },
    dukeMechanics: {
      q1: "O que é a peça Duque?",
      a1: "O Duque é uma peça especial que substitui um Bispo. Ele se move na diagonal (1 casa) para movimentos sem captura, mas pode capturar em todas as 8 direções (apenas casas adjacentes).",
      q2: "O que acontece quando meu Rei é capturado?",
      a2: "Seu Duque se transforma em um novo Rei! As regras de transformação dependem do modo: Rei Instantâneo ou Luta para ser Rei.",
      q3: "Como funciona Luta para ser Rei?",
      a3: "Depois que seu Rei é capturado, seu Duque deve retornar à sua linha de base inicial (fileira 1 para brancas, fileira 8 para pretas) para se transformar em Rei.",
      q4: "As peças Duque podem ser promovidas?",
      a4: "Apenas na variante Peões Selvagens! Quando um peão alcança a última fileira, você pode promovê-lo a Dama, Torre, Bispo, Cavalo ou Duque.",
      q5: "Qual é a diferença entre as skins Rei Instantâneo e Luta para ser Rei?",
      a5: "As skins do Duque vêm em duas versões: A versão 'Rei Instantâneo' aparece durante o jogo normal, enquanto 'Luta para ser Rei' aparece quando seu Duque luta para alcançar a linha de base."
    },
    multiplayer: {
      q1: "Como funciona Partida Rápida?",
      a1: "Partida Rápida emparelha você com outro jogador instantaneamente! Selecione seu modo preferido, clique em 'Encontrar Partida', e você será emparelhado com alguém que escolheu o mesmo modo.",
      q2: "Como crio e gerencio salas privadas?",
      a2: "Vá para a aba 'Criar Sala', insira um nome, escolha a variante, configure as configurações de espectadores e compartilhe o código de 6 caracteres com amigos.",
      q3: "Como entro na sala de um amigo?",
      a3: "Vá para a aba 'Entrar na Sala', insira o código de 6 caracteres compartilhado pelo seu amigo e clique em 'Entrar'.",
      q4: "Quais são as configurações de espectadores?",
      a4: "Privada: Sem espectadores. Solicitar Entrada: Espectadores devem pedir aprovação. Aberta: Qualquer um pode assistir livremente.",
      q5: "Como assisto jogos como espectador?",
      a5: "Vá para a aba 'Espectador' para ver todos os jogos públicos. Filtre por tipo de jogo para encontrar variantes específicas.",
      q6: "Posso conversar durante os jogos?",
      a6: "Sim! Durante jogos multijogador, use o chat do jogo. As mensagens são traduzidas automaticamente se os jogadores falam idiomas diferentes!",
      q7: "Meu tema sincroniza com os oponentes?",
      a7: "Sim! Se você é o anfitrião, seu tema do tabuleiro, skins das peças e skins do duque sincronizam automaticamente com todos os jogadores."
    },
    customization: {
      q1: "Quais skins de peças estão disponíveis?",
      a1: "Temos mais de 20 conjuntos: Dourado 3D, Obsidiana 3D, Vintage, Kawaii, Fábula, Gótico, Colossal, Ametista Roxo, Safira Azul, Reino de Pedra e Areia, e mais!",
      q2: "Quais skins de duque estão disponíveis?",
      a2: "Mais de 50 skins em categorias: Metálico (Ouro, Prata), Cor (Roxo, Azul, Esmeralda), Branco (Espartano, Águia), Preto (Aço, Coroa), Gema, Reino, Premium 3D, e mais!",
      q3: "Como mudo as skins das peças?",
      a3: "Configurações → Skins das Peças. Você pode definir skins diferentes para os lados Branco e Preto separadamente! Use 'Visualizar Ambos os Lados' para ver como ficarão juntos.",
      q4: "Como mudo as skins do duque?",
      a4: "Configurações → Skins do Duque. Selecione skins categorizadas por Branco, Preto ou Neutro. Cada duque tem variantes Rei Instantâneo e Luta para ser Rei.",
      q5: "O que são Pacotes de Temas?",
      a5: "Pacotes de Temas agrupam skins de peças, skins de duque e temas de tabuleiro! Pacotes disponíveis: Royal Gold, Dark Knight, Vintage Classic e pacotes Batalha dos Reinos!",
      q6: "Como obtenho um tema aleatório?",
      a6: "Clique em 'Pacote de Tema Aleatório' para aplicar um tema completo aleatório, ou 'Batalha de Reino Aleatória' para um confronto de facções aleatório.",
      q7: "Posso personalizar as cores das coordenadas?",
      a7: "Sim! Configurações → Cor das Coordenadas. Escolha qualquer cor para os números de fileira (1-8) e letras de coluna (a-h)."
    },
    boardFeatures: {
      q1: "Quais são os modos de visualização?",
      a1: "Dois modos: Perspectiva 3D (com profundidade e sombras) e Vista Superior (plano, tradicional). Alterne em Configurações → Modo de Visualização.",
      q2: "Como funciona o dimensionamento do tabuleiro?",
      a2: "Configurações → Tamanho do Tabuleiro permite escalar de 80% (Compacto) a 120% (Grande). Padrão é 100%.",
      q3: "Quais temas de tabuleiro estão disponíveis?",
      a3: "Vários temas de cores: Madeira Clássica, Ouro Real, Cavaleiro Negro, Azul Oceano, Verde Floresta, Cinza Pedra, e mais.",
      q4: "Como funcionam as coordenadas?",
      a4: "As coordenadas mostram números de fileira (1-8) e letras de coluna (a-h) nas bordas do tabuleiro. Elas viram corretamente ao usar o botão virar!",
      q5: "O tabuleiro funciona em dispositivos móveis?",
      a5: "Sim! O tabuleiro é totalmente responsivo. No modo paisagem, o tabuleiro se ajusta automaticamente à altura da tela."
    },
    skinStore: {
      q1: "Como acesso a Loja de Skins?",
      a1: "Clique no botão Loja no lobby, ou acesse via Configurações → botão 'Visitar Loja'. A loja tem três abas: Conjuntos Temáticos, Skins de Peças e Skins de Duque.",
      q2: "O que são Conjuntos Temáticos?",
      a2: "Pacotes de temas completos com desconto! Incluem skins de peças, skins de duque e temas de tabuleiro combinando.",
      q3: "Há descontos em pacotes?",
      a3: "Sim! 'Pacote Todas as Skins de Peças' e 'Pacote Todas as Skins de Duque' dão todas as skins com 40% de desconto.",
      q4: "Como funcionam as raridades das skins?",
      a4: "Comum (cinza): Grátis ou básico. Raro (azul): R$9,99-12,99. Épico (roxo): R$12,99-19,99. Lendário (ouro): R$17,99-24,99.",
      q5: "Posso visualizar antes de comprar?",
      a5: "Sim! Passe o mouse sobre qualquer cartão de skin para ver uma prévia. Skins de peças mostram Rei, Dama e Cavalo.",
      q6: "Como equipo skins compradas?",
      a6: "Na Loja, skins que você possui mostram o botão 'Equipar' em vez do preço. Clique em Equipar para aplicar imediatamente."
    },
    trialPayments: {
      q1: "O que é o teste gratuito de 48 horas?",
      a1: "Novos usuários recebem 48 horas de acesso gratuito a TODAS as variantes. Após o teste, Xadrez Padrão e Rei Instantâneo permanecem gratuitos.",
      q2: "Quanto custam as variantes?",
      a2: "Luta para ser Rei e Modo Handicap: R$14,99, Escolha do Jogador: R$19,99, Peões Selvagens e Dois Duques: R$24,99. Ou pegue o Pacote Todas as Variantes por R$44,99!",
      q3: "Quanto custam as skins?",
      a3: "Skins individuais: R$9,99-24,99 dependendo da raridade. Pacotes: ~40% de desconto. Conjuntos Temáticos: R$44,99-64,99.",
      q4: "Posso jogar como convidado?",
      a4: "Sim! O modo convidado permite jogar imediatamente sem se registrar. No entanto, o histórico de jogos não será salvo.",
      q5: "Como funcionam os pagamentos?",
      a5: "Todos os pagamentos são processados com segurança via Stripe. Compras únicas desbloqueiam o conteúdo para sempre. Sem assinaturas necessárias."
    },
    strategyTips: {
      q1: "Estratégia de abertura do Duque?",
      a1: "Posicione seu Duque para controlar as diagonais centrais cedo. Sua capacidade única de captura em 8 direções o torna excelente para ameaçar múltiplas peças.",
      q2: "Quando escolher Rei Instantâneo vs Luta para ser Rei?",
      a2: "Escolha Rei Instantâneo se seu Duque está bem posicionado. Escolha Luta para ser Rei se seu Duque já está perto da linha de base.",
      q3: "Estratégia da variante Dois Duques?",
      a3: "Proteja ambos os Duques cuidadosamente - eles são suas 'vidas extras'! Quando seu Rei for capturado, escolha o Duque mais seguro para a transformação.",
      q4: "Final de Peões Selvagens?",
      a4: "Considere promover peões a Duques como 'seguro do Rei' - se seu Rei for capturado depois, um Duque promovido pode se tornar seu novo Rei!",
      q5: "Usar a virada do tabuleiro estrategicamente?",
      a5: "Vire o tabuleiro para ver posições da perspectiva do seu oponente! Isso ajuda a identificar ameaças que você pode não perceber."
    },
    troubleshooting: {
      q1: "O jogo carrega lentamente",
      a1: "Tente o botão Solução de Problemas para executar diagnósticos. Verifique sua conexão com a internet. Tente atualizar a página (Ctrl+F5).",
      q2: "O multijogador não conecta",
      a2: "Use a Solução de Problemas para verificar o status da conexão WebSocket. Certifique-se de estar logado. Verifique problemas de firewall/VPN.",
      q3: "As configurações não salvam",
      a3: "As configurações usam localStorage. Verifique se seu navegador permite. Tente a opção 'Resetar Configurações' na Solução de Problemas.",
      q4: "Onde está o histórico de movimentos?",
      a4: "A barra lateral do histórico de movimentos aparece no lado DIREITO durante jogos ativos. Requer largura do navegador > 768px.",
      q5: "O controle deslizante de tamanho do tabuleiro não funciona?",
      a5: "Tente: 1) Atualizar a página. 2) Limpar cache do navegador. 3) Verificar se você está em um jogo. 4) Tentar modo de visualização diferente.",
      q6: "As peças parecem muito pequenas/grandes?",
      a6: "Diferentes skins de peças têm tamanhos ideais diferentes. Vá em Configurações → Tamanho do Tabuleiro para ajustar.",
      q7: "Esqueci minha senha?",
      a7: "Vá para a página Conta → 'Esqueceu a Senha?' → Responda suas perguntas de segurança → A senha será enviada para seu email.",
      q8: "Como contato o suporte?",
      a8: "Use a Solução de Problemas para problemas técnicos. Para problemas de cobrança/conta, envie um email da página Conta."
    },
    tips: {
      tip1: "O Duque pode capturar em 8 direções mas só se move na diagonal quando não captura!",
      tip2: "No modo Luta para ser Rei, seu Duque deve alcançar a linha de base para se transformar.",
      tip3: "Posicione seu Duque para controlar múltiplas casas - seu movimento único é poderoso!",
      tip4: "Na variante Dois Duques, proteger ambos os Duques dá mais opções de recuperação.",
      tip5: "Em Peões Selvagens, promover a Duque dá 'seguro do Rei' se capturado.",
      tip6: "Partida Rápida: Selecione o mesmo modo que seu oponente para emparelhar instantaneamente!",
      tip7: "Salas criadas aparecem em 'Minhas Salas', salas entradas aparecem em 'Salas Entradas'.",
      tip8: "Defina sua sala como 'Aberta' para deixar qualquer um assistir seus jogos épicos!",
      tip9: "Modo Solicitação: Jogadores devem aprovar espectadores - perfeito para aulas particulares.",
      tip10: "Você pode criar no máximo 5 salas. Cancele ou complete para criar mais.",
      tip11: "Clique em Configurações para mudar as cores do tabuleiro e das peças a qualquer momento.",
      tip12: "Todos os seus movimentos são registrados na barra lateral à direita da tela.",
      tip13: "As mensagens são traduzidas automaticamente para jogadores que falam idiomas diferentes!",
      tip14: "Cada sala privada recebe um código único de 6 caracteres para compartilhar com amigos.",
      tip15: "Pacotes de Temas: Obtenha peças, duques e temas de tabuleiro combinando com um clique!",
      tip16: "Tente Pedra e Areia vs Guerreiros da Floresta para uma guerra de facções épica!",
      tip17: "Deixe o jogo escolher um tema aleatório para você - descubra novos favoritos!",
      tip18: "Ametista Roxo e Safira Azul fazem suas peças brilharem!",
      tip19: "Clique no botão virar para ver da perspectiva das pretas - ótimo para análise!",
      tip20: "Gire seu dispositivo para uma visualização maior do tabuleiro em dispositivos móveis!",
      tip21: "Use o controle deslizante nas Configurações para escalar o tabuleiro de 80% a 120%!",
      tip22: "Os conjuntos Colossais apresentam peças esculpidas épicas em mármore e bronze!",
      tip23: "Quatro conjuntos de peças emoji Kawaii fofos - Marrom, Branco, Preto e Bege!",
      tip24: "Os conjuntos Gótico Branco e Preto apresentam designs intrincados de fantasia sombria!",
      tip25: "Fábula Medieval: Cavaleiros cruzados vs guerreiros das trevas - peças de batalha épicas!"
    }
  },

  // Account Manager
  account: {
    title: "Gerenciamento de Conta",
    accountInfo: "Informações da Conta",
    usernameEmail: "Nome de Usuário/Email",
    displayName: "Nome de Exibição",
    accountType: "Tipo de Conta",
    userId: "ID do Usuário",
    guest: "Convidado",
    registered: "Registrado",
    notAvailable: "N/D",
    notificationSettings: "Configurações de Notificações",
    notificationSound: "Som de Notificação",
    notificationSoundDesc: "Tocar um som quando receber notificações",
    security: "Segurança",
    passwordManagement: "Gerenciamento de Senha",
    passwordNote: "Por razões de segurança, não exibimos senhas. Se precisar redefinir sua senha, use a função 'Esqueceu a Senha'.",
    forgotPassword: "Esqueceu a Senha?",
    passwordRecovery: "Recuperação de Senha",
    passwordRecoveryHelp: "Responda suas perguntas de segurança para receber sua senha por email",
    securityQuestion1: "Pergunta de Segurança 1",
    securityQuestion2: "Pergunta de Segurança 2",
    selectQuestion: "Selecione uma pergunta...",
    yourAnswer: "Sua resposta",
    sendPasswordEmail: "Enviar Senha por Email",
    securityQuestions: {
      q1: "Qual era o nome do seu primeiro animal de estimação?",
      q2: "Em que cidade você nasceu?",
      q3: "Qual é o nome de solteira da sua mãe?",
      q4: "Qual era o nome da sua escola primária?",
      q5: "Qual é o seu livro favorito?",
      q6: "Qual era seu apelido de infância?",
      q7: "Qual é o nome do seu professor favorito?",
      q8: "Em que rua você cresceu?"
    },
    dangerZone: "Zona de Perigo",
    deleteAccount: "Excluir Conta",
    deleteAccountDesc: "Excluir permanentemente sua conta e todos os dados associados.",
    deleteWarning: "Isso excluirá permanentemente:",
    deleteWarningItems: {
      account: "Sua conta e perfil",
      gameHistory: "Todo o histórico de jogos",
      friends: "Conexões de amigos",
      purchases: "Variantes compradas",
      settings: "Configurações e preferências"
    },
    typeDelete: "Digite DELETE para confirmar:",
    typeDeletePlaceholder: "Digite DELETE aqui",
    deleteForever: "Excluir Minha Conta Para Sempre",
    deleteConfirmMsg: "Esta ação não pode ser desfeita.",
    deleteSuccess: "Conta excluída com sucesso. Você será desconectado.",
    deleteFailed: "Falha ao excluir conta",
    passwordResetSuccess: "Redefinição de senha bem-sucedida! Sua senha foi enviada para seu endereço de email. Verifique sua caixa de entrada (e pasta de spam).",
    securityAnswersIncorrect: "Respostas de segurança incorretas. Por favor, tente novamente.",
    passwordResetFailed: "Falha na redefinição de senha. Por favor, tente novamente.",
    answerBothQuestions: "Por favor, responda ambas as perguntas de segurança"
  }
};

export default pt;
